import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  HostBinding,
  inject,
  ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { FormFieldComponent } from '@spri/components/form-field';
import { MrnSearchSelectComponent } from '@spri/components/mrn-search-select';
import {
  createManualSurveyFormGroup,
  manualFormOnMrnBlur,
  manualFormShowFieldError,
} from '../../services/manual-form-controls.util';
import { ManualFormService, type ManualFormSelectOption } from '../../services/manual-form.service';

const SELECT_OPTION: ManualFormSelectOption = { value: '', label: 'Select' };

@Component({
  selector: 'spri-manual-form-content',
  standalone: true,
  imports: [FormFieldComponent, ReactiveFormsModule, MrnSearchSelectComponent],
  templateUrl: './manual-form-content.component.html',
  styleUrls: ['./manual-form-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ManualFormContentComponent {
  private readonly manualFormOptions = inject(ManualFormService);
  private readonly cdr = inject(ChangeDetectorRef);

  readonly manualForm = createManualSurveyFormGroup();

  private readonly jointsOptionsRaw = toSignal(this.manualFormOptions.jointsOptions$, {
    initialValue: [] as ManualFormSelectOption[],
  });
  private readonly categoryOptionsRaw = toSignal(this.manualFormOptions.categoryOptions$, {
    initialValue: [] as ManualFormSelectOption[],
  });
  private readonly physicianOptionsRaw = toSignal(this.manualFormOptions.physicianOptions$, {
    initialValue: [] as ManualFormSelectOption[],
  });

  readonly jointsOptions = computed(() => this.withSelectPlaceholder(this.jointsOptionsRaw()));
  readonly categoryOptions = computed(() => this.withSelectPlaceholder(this.categoryOptionsRaw()));
  readonly physicianOptions = computed(() => this.withSelectPlaceholder(this.physicianOptionsRaw()));

  @HostBinding('class')
  readonly classList = 'w-full';

  showFieldError(control: AbstractControl | null): boolean {
    return manualFormShowFieldError(control);
  }

  onMrnBlur(): void {
    manualFormOnMrnBlur(this.manualForm, this.cdr);
  }

  private withSelectPlaceholder(options: ManualFormSelectOption[]): ManualFormSelectOption[] {
    if (!options.length) {
      return [SELECT_OPTION];
    }
    if (options[0]?.value === '') {
      return options;
    }
    return [SELECT_OPTION, ...options];
  }
}
